var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressBarCarinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Group 781",
  xmlns: "http://www.w3.org/2000/svg",
  width: 49.065,
  height: 20.955
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 228",
  fill: "none",
  d: "M0 0h49.065v20.955H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1179",
  d: "M471.134 78.189a38.5 38.5 0 0 0-8.016 1.324c-.34 1.427 1.258 3.48 1.258 3.48l8.028.183c.005-.223-.633-3.55-.844-4.643a.423.423 0 0 0-.415-.343h-.011",
  transform: "translate(-463.071 -78.189)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 222",
  fill: "none",
  d: "M0 0h8.408v7.926H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1230",
  d: "M975.218 69.068a.187.187 0 0 0-.15.228c.176.743.815 3.422 1.18 4.562a.515.515 0 0 0 .463.358l8.43.46.493-1.345-.634-2.38a.566.566 0 0 0-.345-.345 28.017 28.017 0 0 0-8.031-1.639 8.981 8.981 0 0 0-1.4.1",
  transform: "translate(-975.063 -68.967)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 224",
  fill: "none",
  d: "M0 0h10.242v9.68H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 225",
  fill: "none",
  d: "M0 0h3.975v4.006H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ProgressBarCar_inline_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 226",
  fill: "none",
  d: "M0 0h3.976v4.006H0z"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 780",
  clipPath: "url(#ProgressBarCar_inline_svg__a)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 759"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 758",
  clipPath: "url(#ProgressBarCar_inline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1144",
  d: "M22.6 18.253c12.482 0 22.6.491 22.6 1.1s-10.119 1.1-22.6 1.1S0 19.955 0 19.349s10.119-1.1 22.6-1.1",
  fill: "#1e657e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1145",
  d: "M1.905 7.465a5.472 5.472 0 0 1 .586-.675c.14-.142.29-.283.443-.426.187-.173 3.371-3.563 3.371-3.563a1.973 1.973 0 0 1 .31-.663C11.215.893 16.884.966 20.322.771c7.961-.449 13.391 3.006 16.6 4.661 1.762.91 8.2 2.22 8.2 2.22a3.942 3.942 0 0 1 3.8 3.791 9.757 9.757 0 0 1-.113 3.07c-.414.05.065.686.224.882.029.037.047.057.047.057l-.072.5a11.629 11.629 0 0 1-1.812.085c-.71.585-2.431.183-2.431.183a11.173 11.173 0 0 0-.168-1.59c-.952-5.082-5.439-4.042-5.439-4.042-3.13.67-3.633 3.6-3.706 4.785a4.558 4.558 0 0 0-.01.5c.116.884-.446.986-.446.986-1.448-.237-22.874.284-22.874.284-.538-5.667-4.183-5.644-6.059-5.053-3.168 1-3.077 4.9-3.077 4.9a4.029 4.029 0 0 1-1.367-.114c-.555-.134-.8-1.527-.9-2.347-.042-.349-.056-.594-.056-.594-.356-1.165 1.084-3.57 1.084-3.57a2.678 2.678 0 0 1 .174-2.895",
  fill: "#eace0a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1146",
  d: "M40.122 10.466c5.048.094 4.629 5.755 4.629 5.755l-1.1.2c.435-4.239-2.916-5.508-4.615-4.917-4.815 1.674-2.319 6.03-2.319 6.03a1.935 1.935 0 0 1-1.305-.955c-.451-4.858 2.791-6.152 4.711-6.117"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1147",
  d: "M7.696 11.681c4.821.373 4.437 5.44 4.437 5.44l-.708-.037c-.073-4.177-3.317-4.829-4.983-4.15a4.325 4.325 0 0 0-2.819 3.849c-.576-.183-.646.2-.646.2a4.613 4.613 0 0 1 4.723-5.3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1148",
  d: "M39.732 11.296a3.915 3.915 0 1 1-3.825 4.1 3.959 3.959 0 0 1 3.825-4.1",
  fill: "#1a1a1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1149",
  d: "M39.919 12.406a2.88 2.88 0 1 1-2.759 3.012 2.885 2.885 0 0 1 2.759-3.012",
  fill: "#686868"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1150",
  d: "M7.302 12.432a3.915 3.915 0 1 1-3.825 4.1 3.959 3.959 0 0 1 3.825-4.1",
  fill: "#1a1a1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1151",
  d: "M7.488 13.544a2.88 2.88 0 1 1-2.759 3.012 2.885 2.885 0 0 1 2.759-3.012",
  fill: "#686868"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1152",
  d: "M3.009 6.29c.5-.516 3.213-3.4 3.292-3.488a1.973 1.973 0 0 1 .31-.663C11.211.894 16.88.967 20.318.772c7.961-.449 13.391 3.006 16.6 4.661a33.6 33.6 0 0 0 5.644 1.66c1.435.332 2.554.56 2.554.56a3.942 3.942 0 0 1 3.8 3.791l-.015.008a43.359 43.359 0 0 1-6.817-3.441s-3-.205-7.376-.473c-7.561-.458-19.216-1.1-26.519-1.159-1.306-.01-2.474 0-3.453.028a12.373 12.373 0 0 1-2.226.383h-.009c.14-.142.29-.283.443-.426a1.42 1.42 0 0 0 .072-.074",
  fill: "#fcdf12"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1153",
  d: "m37.108 7.455-2.408.082a7.411 7.411 0 0 0-.3-2.573s4.65 2.4 2.713 2.49",
  fill: "#c6a900"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1154",
  d: "M2.003 7.449s4-.747 3.05.517c0 0-2.51 2.457-3.32 2.392a2.678 2.678 0 0 1 .174-2.895Z",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1155",
  d: "M20.59 1.546c3.281-.522 8.26 1.125 9.434 1.538a.565.565 0 0 1 .345.345l.636 2.381-.493 1.345-8.429-.46a.515.515 0 0 1-.463-.358c-.365-1.14-1-3.819-1.18-4.562a.187.187 0 0 1 .15-.228",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1156",
  d: "M20.59 1.546c3.281-.522 8.26 1.125 9.434 1.538a.565.565 0 0 1 .345.345l.636 2.381-.493 1.345-8.429-.46a.515.515 0 0 1-.463-.358c-.365-1.14-1-3.819-1.18-4.562a.187.187 0 0 1 .15-.228",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1157",
  d: "M20.59 1.546c3.281-.522 8.26 1.125 9.434 1.538a.565.565 0 0 1 .345.345l.636 2.381-.493 1.345-8.429-.46a.515.515 0 0 1-.463-.358c-.365-1.14-1-3.819-1.18-4.562a.187.187 0 0 1 .15-.228",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1158",
  d: "M20.59 1.546c3.281-.522 8.26 1.125 9.434 1.538a.565.565 0 0 1 .345.345l.636 2.381-.493 1.345-8.429-.46a.515.515 0 0 1-.463-.358c-.365-1.14-1-3.819-1.18-4.562a.187.187 0 0 1 .15-.228",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1159",
  d: "M44.77 15.388c.611.124 4.3.064 4.3.064l-.072.5a11.626 11.626 0 0 1-1.812.085c-.71.585-2.431.182-2.431.182-.01-.292-.03-.57-.06-.834a.2.2 0 0 1 .079 0",
  fill: "#ddc200"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1160",
  d: "M11.736 12.889c.5-.024.757-1.1.757-1.1-.1-1.063.962-.869 1.367-.979 6.525-1.779 18.134-.111 20.591-.071a13.73 13.73 0 0 1 1.925.7 4.939 4.939 0 0 1 3.969-1.619 4.3 4.3 0 0 1 4.282 4.781l-.043.029c-.952-5.082-5.439-4.042-5.439-4.042a4.617 4.617 0 0 0-3.706 4.785c-.01-.077-2.236.369-2.477.32l-11.937.312-6.539.172s-1.06.224-1.65-1.228a2.806 2.806 0 0 1-.081-.216 13.692 13.692 0 0 0-1.085-1.64c0-.131.018-.2.066-.206",
  fill: "#ddc200"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1161",
  d: "m32.858 15.088-16.938-.617c7.466-1.341 16.938.617 16.938.617",
  fill: "#feeb1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1162",
  d: "M3.15 6.227c-.049.024-.1.046-.141.063.5-.516 3.213-3.4 3.292-3.488A6.217 6.217 0 0 1 3.15 6.227",
  fill: "#feeb1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1163",
  d: "m10.814 1.369-.813.152c.118-.717.813-.152.813-.152",
  fill: "#1a1a1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1164",
  d: "m10.203 1.264-.056.043L9.195.043 9.252 0Z",
  fill: "#1a1a1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1165",
  d: "M3.276 13.463a5.115 5.115 0 0 1 3.045-2.049c4.642-1.084 6.512 3.536 6.512 3.536 3.3-1.548 22.605.36 22.605.36-.021.307-.012.56-.012.56.116.884-.446.986-.446.986-1.448-.237-22.874.284-22.874.284-.538-5.667-4.183-5.644-6.059-5.053-3.168 1-3.077 4.9-3.077 4.9a4.031 4.031 0 0 1-1.367-.114c-.555-.134-.8-1.527-.9-2.347a.145.145 0 0 1 .047.012c.925.376 2.523-1.071 2.523-1.071",
  fill: "#ddc200"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1166",
  d: "M35.906 5.803a2.789 2.789 0 0 1-.308-.189s.123.073.308.189",
  fill: "#fdd134"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1167",
  d: "M37.12 7.346c1.274.088-.469-1.077-1.213-1.543a31.219 31.219 0 0 0 5.841 1.718c-.12.345.409.5.409.5s-34.066-.6-34.016-1.66c0-.047 20.124.377 28.98.986",
  fill: "#feeb1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1168",
  d: "M8.55 2.654a.336.336 0 0 1-.3-.054 6.088 6.088 0 0 0-1.635-.462 54.924 54.924 0 0 1 7.435-.641 33.321 33.321 0 0 0-5.5 1.157",
  fill: "#feeb1a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1169",
  d: "m42.539 7.205.018-.008c1.435.333 2.61.519 2.61.519.085.022.168.046.248.074a3.155 3.155 0 0 1 1.034.547 2.318 2.318 0 0 1 .888 1.737 7.3 7.3 0 0 1-5.156-1.855.736.736 0 0 1-.055-.056l-.047-.048c-1.034-.509.462-.911.462-.911",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1170",
  d: "m34.225 15.206-.649.534a2.221 2.221 0 0 1-.615-.046l-11.937.312-6.539.172s-1.06.224-1.65-1.228c.033-.011.069-.021.1-.034 4.168-1.549 21.285.289 21.285.289",
  fill: "#eace0a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1171",
  d: "M8.095 6.321a5.735 5.735 0 0 0 .049 2.41 5.446 5.446 0 0 0 .765 1.733 5.35 5.35 0 0 0 1.323 1.4h.008a4.462 4.462 0 0 1 1.371 1.273 13.753 13.753 0 0 1 1.075 1.625c.023.066.05.142.081.215a1.956 1.956 0 0 0 1.088 1.2 1.366 1.366 0 0 0 .472.087.958.958 0 0 0 .164-.013l6.534-.172 11.929-.312a2.3 2.3 0 0 0 .627.045.963.963 0 0 0 .725-.353 1.216 1.216 0 0 0 .192-.855 9.706 9.706 0 0 0 .626-3.608 16.984 16.984 0 0 0-.351-3.483l-.011-.047-.047-.009c-1.541-.283-8.61-.591-14.268-.8-6.237-.231-12.219-.4-12.279-.4h-.062Zm.132.089c.656.018 6.322.178 12.215.4 5.6.207 12.573.51 14.2.789a16.994 16.994 0 0 1 .337 3.4 9.537 9.537 0 0 1-.623 3.571l-.008.02v.021a1.1 1.1 0 0 1-.161.762.825.825 0 0 1-.62.3 2.171 2.171 0 0 1-.595-.045h-.017l-11.937.312-6.546.172h-.006a1.133 1.133 0 0 1-.571-.07 1.861 1.861 0 0 1-1-1.114 3.056 3.056 0 0 1-.08-.212l-.005-.012a13.9 13.9 0 0 0-1.092-1.65 4.61 4.61 0 0 0-1.416-1.311A5.412 5.412 0 0 1 8.22 6.415",
  fill: "#c6a900"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1172",
  d: "M20.555 6.775c.05.308 1.213 7.568.568 9.162l-.135-.055c.63-1.556-.565-9.007-.577-9.083Z",
  fill: "#c6a900"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1173",
  d: "M19.162 1.13a28.736 28.736 0 0 1 14.657 3.22c.965.452.884 3.181.884 3.181v.008c-4.033-.244-9.229-.54-14.309-.773-4.446-.2-8.8-.356-12.209-.385a.094.094 0 0 1-.014-.045 31.5 31.5 0 0 1 .569-3.241c.232-1.524 7.78-1.783 10.426-1.963",
  fill: "#c6a900"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1174",
  d: "M17.768 1.639a.422.422 0 0 1 .426.343c.211 1.094.85 4.42.844 4.643l-8.028-.183s-1.6-2.053-1.258-3.48a38.5 38.5 0 0 1 8.016-1.324",
  fill: "#7fcbe1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1175",
  d: "M31.041 3.583a10.415 10.415 0 0 1 2.385 1.148c.363.3.209 1.261.209 1.261-.613.385-2.222-.048-2.222-.048a10.86 10.86 0 0 1-.553-2.207.136.136 0 0 1 .18-.154",
  fill: "#6db0cb"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1176",
  d: "M33.025 5.868c-.021 1.2-1.771.972-1.771.972-.6-.505.021-1.729.021-1.729 1.625-.3 1.75.757 1.75.757",
  fill: "#eace0a"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 764"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 763",
  clipPath: "url(#ProgressBarCar_inline_svg__b)",
  transform: "translate(9.705 1.639)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 762",
  opacity: 0.57
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 761"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 760",
  clipPath: "url(#ProgressBarCar_inline_svg__c)",
  fill: "#fff",
  transform: "translate(.11 -1.113)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1177",
  d: "m8.409 6.271-.579.521L2.271.521 2.85 0Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1178",
  d: "M6.851 6.763 5.559 7.928 0 1.657 1.292.494Z"
}))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 766"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 765",
  clipPath: "url(#ProgressBarCar_inline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1180",
  d: "M20.59 1.546c3.281-.522 8.26 1.125 9.434 1.538a.565.565 0 0 1 .345.345l.636 2.381-.493 1.345-8.429-.46a.515.515 0 0 1-.463-.358c-.365-1.14-1-3.819-1.18-4.562a.187.187 0 0 1 .15-.228",
  fill: "#7fcbe1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1181",
  d: "M25.793 20.828a.062.062 0 0 1 0 .123.062.062 0 0 1 0-.123",
  fill: "#c4c4c4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1182",
  d: "M22.689 6.751c-.081-1.365.059-.5.059-.5l1.918-1.609a6.553 6.553 0 0 1 1.247.023c.185 0 .591.045.591.045l1.434 1.541s-.014.3-.041.758",
  fill: "#ec4e50"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1183",
  d: "M23.095 5.218a2.926 2.926 0 0 1 1.571-.573 9.53 9.53 0 0 1 .217 2.212l-2.018-.119c.147-.922.23-1.519.23-1.519",
  fill: "#ec4e50"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1184",
  d: "m27.769 6.991-1.245-.053c-.014-1.087-.019-2.224-.019-2.224a3.764 3.764 0 0 1 1.377.5Z",
  fill: "#ec4e50"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1185",
  d: "M22.033 6.72a4.792 4.792 0 0 1 1.063-1.5 2.121 2.121 0 0 1 1.571-.573c-.032 0-1.43-.024-.609 2.165",
  fill: "#ec4e50"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1186",
  d: "M24.057 6.811h-.472a3.825 3.825 0 0 1 .49-1.07Z",
  fill: "#b22c2d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1187",
  d: "m25.073 3.468.89.513.224.129.092.59.014.092s-.027.367-.588.367c-.827 0-.82-.406-.82-.406Z",
  fill: "#f9d2b9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1188",
  d: "m25.963 3.981.224.129.092.59c-1.385 0-1.119-.882-1.119-.882s.5.09.8.163",
  fill: "#f8ae8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1189",
  d: "M26.481 3.117a.168.168 0 0 1 .125.091.372.372 0 0 1 .038.156.3.3 0 0 1-.019.148.181.181 0 0 1-.224.088v-.426c0-.038.046-.06.083-.056",
  fill: "#f7c6b3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1190",
  d: "M26.324 2.627a7.978 7.978 0 0 1 .2.812 2.471 2.471 0 0 1 .042.392.441.441 0 0 1-.042.225.921.921 0 0 1-1.107.27 2.089 2.089 0 0 1-.433-1.081c-.021-.534 1.055-.887 1.345-.617",
  fill: "#f9d2b9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1191",
  d: "M25.079 2.069a.94.94 0 0 1 .314-.109c.093-.013.2.014.3 0a1.829 1.829 0 0 1 .386.041c.237.056.543.267.542.54a.329.329 0 0 1-.21.31.965.965 0 0 1-.753-.1.334.334 0 0 1 .08.125.048.048 0 0 1 0 .036c-.008.016-.031.018-.049.017a1.113 1.113 0 0 1-.433-.115c.1.1.055.307 0 .421a.868.868 0 0 0-.054.525c-.205.336-.52.025-.52.025a1.676 1.676 0 0 1-.05-1.248 1.065 1.065 0 0 1 .444-.465",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1192",
  d: "M26.04 1.992a.762.762 0 0 1 .568.215.45.45 0 0 1 .125.311.413.413 0 0 1-.151.305.377.377 0 0 1-.1.058.352.352 0 0 1-.1.022.243.243 0 0 1-.1-.012.169.169 0 0 1-.1-.075.048.048 0 0 1 0-.047.049.049 0 0 1 .04-.023h.076a.573.573 0 0 0 .071 0h.016c-.016 0 .017 0 0 0l.033-.008.015-.005h.012l.028-.014.025-.017.011-.01.024-.025.008-.01c-.005.008.012-.014 0 0l.005-.008a.328.328 0 0 0 .017-.028l.009-.017v-.006a.016.016 0 0 0 0-.007c0-.008.007-.016.009-.025a.34.34 0 0 0 .008-.035s0 .009 0 0v-.018a.316.316 0 0 0 0-.039v-.025c0-.006-.006-.024-.009-.036l-.005-.016a.1.1 0 0 1-.006-.016l-.008-.017a.47.47 0 0 0-.038-.06c0-.007 0-.007 0 0l-.011-.013-.025-.026-.025-.023-.012-.01-.007-.006a.992.992 0 0 0-.12-.074l-.037-.018h-.009l-.02-.008a1.05 1.05 0 0 0-.073-.025.844.844 0 0 0-.148-.03.028.028 0 0 1 0-.055",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1193",
  d: "M26.388 2.75c.016 0-.017 0 0 0",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1194",
  d: "M26.299 2.749",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1195",
  d: "M26.438 2.736h.008-.006",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1196",
  d: "M26.501 2.7h.006",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1197",
  d: "M26.282 2.11",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1198",
  d: "M26.583 2.593v-.008.008",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1199",
  d: "M26.535 2.292",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1200",
  d: "M26.58 2.37",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1201",
  d: "M26.604 2.522c0 .009 0 0 0 0s0-.009 0 0",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1202",
  d: "M26.449 2.207",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1203",
  d: "M26.548 2.654c.009-.011-.008.012 0 0",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1204",
  d: "M24.63 2.614v.006-.009",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1205",
  d: "M24.568 2.841v.007-.011",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1206",
  d: "M24.745 2.419",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1207",
  d: "M24.85 2.311",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1208",
  d: "m24.607 3.269.005.011v.01l-.009-.021",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1209",
  d: "M24.802 3.545",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1210",
  d: "M24.686 3.406v-.005",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1211",
  d: "M24.607 2.371a.664.664 0 0 1 .269-.2l.036-.013a.048.048 0 0 1 .037.088.564.564 0 0 0-.084.049l-.017.013-.011.009-.035.032-.034.036-.015.018-.008.01c-.02.027-.04.054-.057.083a.9.9 0 0 0-.049.091l-.01.023v.009-.006.011l-.018.049a1.024 1.024 0 0 0-.028.1l-.01.053v.021-.007.026a1.011 1.011 0 0 0 0 .228v-.012.023-.011a.813.813 0 0 0 .049.182l-.005-.011.009.021v-.01a.711.711 0 0 0 .037.074.57.57 0 0 0 .026.041l.011.016v.005l.005.006c.02.025.041.049.063.073a.488.488 0 0 1 .042.051l.007.01a.112.112 0 0 1 .021.044.06.06 0 0 1-.041.074.162.162 0 0 1-.03 0 .106.106 0 0 1-.035-.008.217.217 0 0 1-.054-.025.487.487 0 0 1-.078-.066.728.728 0 0 1-.1-.154.909.909 0 0 1-.091-.361 1.034 1.034 0 0 1 .047-.357 1.016 1.016 0 0 1 .169-.323",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1212",
  d: "M24.56 3.084v.023-.023",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1213",
  d: "M25.001 3.319a.089.089 0 0 1 .076.035.243.243 0 0 1 .056.1 1.351 1.351 0 0 0 .142.348.141.141 0 0 1-.112.1.324.324 0 0 1-.293-.5.216.216 0 0 1 .131-.083",
  fill: "#f9d2b9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1214",
  d: "M25.917 3.132a.021.021 0 0 1 .022.02 1.227 1.227 0 0 0 .076.365c.067-.009.192-.019.213.036s-.084.19-.117.23a.021.021 0 0 1-.016.008.022.022 0 0 1-.014 0 .022.022 0 0 1 0-.03.435.435 0 0 0 .11-.187c-.006-.015-.088-.021-.182-.007a.021.021 0 0 1-.022-.011 1.2 1.2 0 0 1-.088-.4.021.021 0 0 1 .02-.023",
  fill: "#f7a18a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1215",
  d: "M25.637 3.359a.064.064 0 0 1 .077.045.064.064 0 0 1-.032.084.063.063 0 0 1-.077-.045.064.064 0 0 1 .032-.084"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1216",
  d: "M26.21 3.249a.063.063 0 0 1 .077.045.059.059 0 1 1-.077-.045"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1217",
  d: "M25.497 3.534a.2.2 0 1 1-.2.24.221.221 0 0 1 .2-.24",
  fill: "#f8ae8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1218",
  d: "M26.517 3.349a2.471 2.471 0 0 1 .042.392.215.215 0 0 1-.243-.151.223.223 0 0 1 .2-.24",
  fill: "#f8ae8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1219",
  d: "M25.887 3.91a.217.217 0 0 1 .075-.006.6.6 0 0 0 .228-.033.266.266 0 0 1 .041-.012.073.073 0 0 1 .023 0 .066.066 0 0 1 .041.073.209.209 0 0 1-.072.139.247.247 0 0 1-.093.052.268.268 0 0 1-.232-.04.2.2 0 0 1-.026-.023.114.114 0 0 1-.031-.114.064.064 0 0 1 .045-.037"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1220",
  d: "M25.961 3.905a.6.6 0 0 0 .228-.033.267.267 0 0 1 .041-.012.067.067 0 0 1 0 .051.081.081 0 0 1-.042.031.5.5 0 0 1-.218.036.1.1 0 0 1-.058-.017.081.081 0 0 1-.025-.05.217.217 0 0 1 .075-.006",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1221",
  d: "M26.222 4.073a.248.248 0 0 1-.093.052.268.268 0 0 1-.232-.04.3.3 0 0 1 .192-.059.2.2 0 0 1 .134.048",
  fill: "#f3888a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1222",
  d: "M25.728 3.074a.043.043 0 0 1 .025.055.042.042 0 0 1-.055.025.193.193 0 0 0-.255.109.043.043 0 0 1-.039.027.042.042 0 0 1-.016 0 .043.043 0 0 1-.024-.056.273.273 0 0 1 .363-.157",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1223",
  d: "M26.388 3.053a.043.043 0 0 1 0 .06.042.042 0 0 1-.06 0 .191.191 0 0 0-.277-.012.042.042 0 0 1-.06 0 .043.043 0 0 1 0-.06.273.273 0 0 1 .4.019",
  fill: "#5d2414"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1224",
  d: "m30.857 6.24-.162.412-.184.5-2.116-.115.673-.32c.485.413 1.79-.48 1.79-.48",
  fill: "#f9d2b9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1225",
  d: "m27.862 5.195 1.316 1.326-.451.537-.6-.016-.919-.067s.072-1.362.089-1.421a3.7 3.7 0 0 1 .569-.359",
  fill: "#ec4e50"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1226",
  d: "m28.123 7.041-.345-.009s-.23-1.052-.06-1.309a7.079 7.079 0 0 1 .405 1.318",
  fill: "#b22c2d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1227",
  d: "m29.185 6.776-.087.3-.2-.011.173-.347Z",
  fill: "#f8ae8c"
})))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 771"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 770",
  clipPath: "url(#ProgressBarCar_inline_svg__d)",
  transform: "translate(20.434 1.445)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 769",
  opacity: 0.56
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 768"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 767",
  clipPath: "url(#ProgressBarCar_inline_svg__e)",
  fill: "#fff",
  transform: "translate(-.697 -1.344)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1228",
  d: "m10.241 8.029-.544.44L3.353.502l.544-.44Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1229",
  d: "M8.462 7.967 6.344 9.68-.004 1.713 2.114 0Z"
}))))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 779"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 778",
  clipPath: "url(#ProgressBarCar_inline_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 774",
  opacity: 0.55,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  }
}, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 773"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 772",
  clipPath: "url(#ProgressBarCar_inline_svg__f)",
  transform: "translate(5.589 14.433)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1231",
  d: "M1.988 0A2 2 0 1 1 0 2a2 2 0 0 1 1.988-2",
  fill: "#8e8e8e"
}))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 777",
  opacity: 0.55,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  }
}, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 776"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 775",
  clipPath: "url(#ProgressBarCar_inline_svg__g)",
  transform: "translate(38.032 13.235)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1232",
  d: "M1.988 0A2 2 0 1 1 0 2a2 2 0 0 1 1.988-2",
  fill: "#8e8e8e"
})))))))));
export default SvgProgressBarCarinline;